<template>
  <div class="zoomedWrapper" :class="{'zoomed': isZoomed}">
    <template v-if="submissionsCount || columns.length">
    <div>
      <div class="dragable" v-if="showDragable">
        <draggable v-model="columns" class="list">
          <transition-group>
            <div
                v-for="item in columns"
                :key="item.fieldName"
                @click="toggleItemVisibility(item)"
            >
              {{ item.label ? item.label : item.fieldName }}
              <i class="fas fa-eye-slash" v-if="item.hidden"></i>
              <i class="fas fa-eye" v-else></i>
            </div>
          </transition-group>
        </draggable>
        <button type="button" @click="saveColumnsOrder">SAVE ORDER</button>
      </div>
      <div class="wrapper">
        <div style="display:flex; align-items: center; justify-content: space-between;">
          <div style="display:flex; align-items: center;">
            <h1 class="header">{{ title }}</h1>
            <div v-if="operation.saisieFormSchema && (href = saisieHref(this.$route.params._id))">
              <a style="padding: 5px 10px;" :href="href" target="_blank"
                 class="text-decoration-none badge-gray">SAISIE</a>
            </div>
          </div>
          <div>
            <button style="margin-right: 10px;" type="button" @click="showDragable=!showDragable">
              CHANGE ORDER
            </button>
            <button class="btn-zoom" :class="{'zoomed' : isZoomed}" type="button" @click="isZoomed = !isZoomed">
              <i v-if="!isZoomed" class="fas fa-expand-alt"></i>
              <i v-if="isZoomed" class="fas fa-compress-alt"></i>
            </button>
          </div>
        </div>
        <form class="search" @submit.prevent="loadSubmissions(true)">
          <input type="text" placeholder="Search" v-model="search"/>
          <button class="advanced-filters__btn" :class="showFilter ? 'active' : ''" type="button" @click="showFilter=!showFilter">
            <span v-if="filterOptionsIsFilled" class="advanced-filters__badge">{{filterOptions.length}}</span><i class="fas fa-filter"></i>
          </button>
          <button type="submit"><i class="fas fa-search"></i></button>
          <select v-model="limit">
            <option selected>25</option>
            <option>50</option>
            <option>75</option>
            <option>100</option>
          </select>
          <button :disabled="loadingCsv || loading || !submissionsCount" class="btnWithSpinner" @click.prevent="downloadCSVData">
            <i v-if="loadingCsv" class="fas fa-circle-notch fa-spin"></i>
            <span>Export CSV</span>
          </button>
          <div class="advanced-filters" v-if="showFilter">
            <div class="advanced-filters__item" v-for="(el, i) in rawFilterOptions" :key="i">
              Where
              <select style="width: 175px;" v-model="el.field">
                <option v-for="item in columns" v-if="!item.hidden">{{ item.fieldName }}</option>
              </select>
              <div v-if="el.field" style="display:flex; column-gap: 10px">
                <!-- text condtion -->
                <select v-model="el.condition" v-if="!['date','createdAt','updatedAt'].includes(el.field)">
                  <option v-for="condition in filteringConditions">{{ condition }}</option>
                </select>
                <!-- date condtion -->
                <select v-model="el.condition" v-else>
                  <option v-for="condition in filteringConditionsDate">{{ condition }}</option>
                </select>
                <!-- date value -->
                <input
                  v-if="['is on day', 'is before', 'is after'].includes(el.condition)"
                  type="date"
                  v-model="el.value"
                >
                <!-- text value -->
                <input
                  v-else-if="el.condition && !['is not null', 'is null'].includes(el.condition)"
                  type="text"
                  v-model="el.value"
                >
                <!-- ignore case checkbox -->
                <input
                  v-if="el.condition && !['is on day', 'is before', 'is after', 'is not null', 'is null'].includes(el.condition)"
                  type="checkbox"
                  v-model="el.ignoreCase"
                  title="Ignore case?"
                >
              </div>
              <button style="margin-left: auto;" type="button" v-if="rawFilterOptions.length>1"
                      @click.stop="deleteFilterOption(el)"><i class="fas fa-times"></i></button>
            </div>
            <div class="advanced-filters__buttons">
              <button type="button" @click="addFilterOption()">Add filter</button>
              <div>
                <button @click.prevent="clearFilterOptions">Clear</button>
                <button type="submit">Apply</button>
              </div>
            </div>
          </div>
        </form>
        <div style="display:flex; align-items: center; justify-content: space-between; padding: 5px;">
          <div>
            <button
                type="button"
                style="margin: 5px; border: red 2px solid; color: red"
                @click="deleteItems(selectedItemIds)"
                :disabled="!selectedItemIds.length"
            >
              <i class="fa fa-trash-o" aria-hidden="true"></i>
            </button>
            <button
                type="button"
                v-if="!changeStatus"
                style="margin: 5px"
                @click="changeStatus = true"
                :disabled="!selectedItemIds.length"
            >
              CHANGE STATUS
            </button>
            <div v-if="changeStatus" style="display: inline">
              <button type="button" style="margin: 5px" @click="changeStatus = false">
                CANCEL
              </button>
              <button
                  type="button"
                  style="margin: 5px"
                  v-for="(status, i) in statuses"
                  :key="i"
                  @click="changeItemsStatus(selectedItemIds, status)"
                  :disabled="!selectedItemIds.length || (status.value==='REFUND_DONE' && !isAllRefundOrValid)"
              >
                {{ status.label }}
              </button>
            </div>
            <button
                type="button"
                v-if="!changeStatus"
                style="margin: 5px"
                @click="sendAction('remise-virement', 'REFUND_DONE')"
                :disabled="!selectedItemIds.length || !isAllRefundOrValid"
            >REMISE VIREMENT</button>
            <button
                type="button"
                v-if="!changeStatus"
                style="margin: 5px"
                @click="sendAction('send-to-logistic', 'SENT_TO_LOGISTIC')"
                :disabled="!selectedItemIds.length"
            >SEND TO LOGISTIC</button>
          </div>
          <span>
            {{submissionsCount}} {{submissionsCount > 1 ? 'résultats' : 'résultat'}}
          </span>
        </div>
        <div v-if="!submissionsCount && !loading" class="not-found">
          Aucun résultat
        </div>
        <LoaderSpinner v-if="loading"/>
        <div v-if="submissionsCount && !loading" class="submission-table__wrapper">
          <table class="submission-table">
            <thead>
              <tr>
                <th>
                  <input
                    type="checkbox"
                    :checked="data.filter((el) => el.checked).length"
                    @change="toggleCheckedItems"
                  />
                </th>
                <th></th>
                <th>Get Info</th>
                <th>Page status</th>
                <template v-for="({ fieldName, hidden, label }, i) in columns">
                  <th :key="i" v-if="!hidden">
                    <span
                      >{{ label ? label : fieldName }}
                      <i
                        v-if="!fieldName.includes('.')"
                        @click="sort(fieldName)"
                        class="fa fa-sort"
                        aria-hidden="true"
                      ></i
                    ></span>
                  </th>
                </template>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in data" :key="item._id">
                <td>
                  <input
                    type="checkbox"
                    :checked="selectedItemIds.includes(item._id)"
                    @change="checkItem(item, $event)"
                  />
                </td>
                <td>
                  <i
                    class="fa fa-trash-o"
                    @click="deleteItems(item._id)"
                    aria-hidden="true"
                  ></i>
                </td>
                <td>
                  <button type="button" @click="goToSubmission(item._id)">INFO</button>
                </td>
                <td class="nowrap">
                  <button type="button" @click="copySubmissionStatusLink(item)" title="Copier le lien de la page status">
                    <i class="fa fa-copy" aria-hidden="true"></i>
                  </button>
                  <button type="button" @click="goToSubmissionStatus(item)" title="Voir la page status">
                    <i class="fa fa-external-link" aria-hidden="true"></i>
                  </button>
                </td>
                <template
                  v-for="({ fieldName, hidden }, i) in columns"
                >
                  <td v-if="!hidden" :key="i" @contextmenu="openContextual($event, item._id, fieldName)">
                    <span
                      class="cell__content"
                      v-if="fieldName && deepFieldAccess(item, fieldName) != null"
                    >
                      <span>{{ deepFieldAccess(item, fieldName) }}</span>
                      <i v-if="!fieldName.includes('.')" style="padding-left: 10px" class="fas fa-filter"></i>
                    </span>
                    <div class="cell__content__hover">
                        <span>{{ deepFieldAccess(item, fieldName) }}</span>
                      <i
                        v-if="!fieldName.includes('.')"
                        style="padding-left: 10px"
                        @click.stop="filterDataBtn(item[fieldName], fieldName)"
                        class="fas fa-filter"
                      ></i>
                    </div>
                  </td>
                </template>
              </tr>
            </tbody>
            <div class="contextual" ref="contextual"
              :style="'z-index:100;position: absolute;top:'+contextualPosition.y+'px;left:'+contextualPosition.x+'px;'"
              v-show="editing"
              @click.stop=""
            >
              <ul v-if="editing && !editing.started">
                <li @click="edit()">Edit</li>
              </ul>
              <form v-else-if="editing && editing.started" @submit.prevent="save()" @keyup.esc="cancelEdit">
                  <div>
                    <input :type="editing.type" ref="editInput" name="value" v-model="editing.value"/>
                    <button type="submit" value="Save" :disabled="!editingDirty">Save</button>
                    <button @click="cancelEdit">Discard</button>
                  </div>
                  <p v-if="editing && editing.error">{{ editing.error }}</p>
              </form>

            </div>

          </table>
        </div>
      </div>
      <div class="pagination__wrapper" v-if="totalPages">
        <div class="pagination">
          <button type="button" @click="changePage('prev')" :disabled="page === 1">
            &lsaquo; Précédent
          </button>
          <template v-for="i in totalPages">
            <button type="button"
              v-if="
                i < 2 || (i > page - 3 && i < page + 3) || i > totalPages - 1
              "
              :class="{ active: i === page }"
              @click="changePage(i)"
              :key="i"
            >
              {{ i }}
            </button>
            <span v-else-if="i === 2 || i === page + 3" :key="i">•••</span>
          </template>
          <button type="button" @click="changePage('next')" :disabled="page === totalPages">
            Suivant &rsaquo;
          </button>
        </div>
      </div>
    </div>
    </template>
    <LoaderSpinner v-if="loading && !submissionsCount && !columns.length"/>
    <div v-if="!loading && !submissionsCount && !columns.length" class="not-found">
      Aucun résultat
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import moment from "moment";
import { downloadBlob } from '@/utils'
import LoaderSpinner from "@/components/LoaderSpinner";


const emailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

export default {
  components: {
    LoaderSpinner,
    draggable,
  },
  data() {
    return {
      filteringConditions: ['is','is not','starts with','ends with','contains','not contains', 'is not null', 'is null'],
      filteringConditionsDate: ['is on day','is before','is after'],
      rawFilterOptions: [{field:'',condition:'is',value:''}],
      showFilter: false,
      isZoomed: false,
      showDragable: false,
      contextualPosition: {
        x: 0,
        y: 0,
      },
      dates: [],
      editing: null,
      operation: {},
      title: undefined,
      data: [],
      columns: [],
      loading: false,
      loadingCsv: false,
      sortDirection: "asc",
      sortColumn: undefined,
      search: "",
      page: 1,
      limit: localStorage.limit || 25,
      totalPages: 0,
      submissionsCount: 0,
      selectedItemIds: [],
      changeStatus: false,
      statuses: [
        { value: "PENDING", label: "PENDING" },
        { value: "REFUND_DONE", label: "REFUND DONE" },
        { value: "SHIPPED", label: "SHIPPED" },
        { value: "SENT_TO_LOGISTIC", label: "SENT TO LOGISTIC" },
      ],
    };
  },
  methods: {
    addFilterOption(filter = undefined) {
      if (filter && !this.filterOptionsIsFilled) {
        this.rawFilterOptions = [];
      }
      this.rawFilterOptions.push(filter || {
        field: '',
        condition: 'is',
        value: ''
      });
      this.showFilter = true;
    },
    deleteFilterOption(filter) {
      this.rawFilterOptions = this.rawFilterOptions.filter(el => el !== filter)
    },
    clearFilterOptions() {
      this.rawFilterOptions = [{field: '', condition: 'is', value: ''}]
    },
    cancelEdit() {
      this.editing = null;
    },
    async save() {
      const { id, column, type, value } = this.editing;

      let newValue = value;
      let displayedValue = value;
      switch (type) {
        case 'checkbox':
          newValue = !!newValue;
          break;
        case 'datetime-local':
          newValue += ':00.000Z';
          displayedValue = this.normalizeDatetime(newValue);
          break;
        case 'number':
        case 'text':
        default:
          break;
      }

      try {
        const data = await this.$axios.post(
          `/api/v2/data/${id}/edit`,
          {
            key: column,
            value: newValue,
          },
        );
        this.deepFieldSet(this.data.find(({_id}) => _id === id), column, displayedValue);
        this.editing = null;
      } catch (e) {
        this.editing.error = e.response.data.error;
      }
    },
    isEditing(editing, id, column) {
      return editing && editing.started && editing.id === id && editing.column === column;
    },
    openContextual(event,id, column) {
      function getContextualPosition(event, contextual) {
        const rect = contextual.parentNode.getBoundingClientRect();
        const baseLeft = rect.left + window.scrollX;
        const baseTop = rect.top + window.scrollY;

        return {
          x: event.pageX - baseLeft,
          y: event.pageY - baseTop,
        };
      }
      this.contextualPosition = getContextualPosition(event, this.$refs.contextual);
      event.preventDefault();

      const row = this.data.find(({_id}) => _id === id);
      let originalValue = this.deepFieldAccess(row, column);
      let type = 'text';
      switch(typeof originalValue) {
        case 'number':
          type = 'number';
          break;
        case 'boolean':
          type = 'checkbox';
          break;
        case 'string':
          if (this.dates.includes(column)) {
            type = 'datetime-local';
            originalValue = this.localToIsoDatetime(originalValue).substring(0, 19);
          }
          else if (originalValue.match(emailRegex))
            type = 'email';
          break;
        case 'object':
          break;
      }
      this.editing = {
        id,
        column,
        error: null,
        type,
        started: false,
        value: originalValue,
        originalValue,
      };
    },
    edit() {
      this.editing.started = true;
      this.$nextTick(() => this.$refs.editInput.focus());
    },
    closeIfNotEditing() {
      if (this.editing && !this.editing.started) this.closeContextual();
    },
    closeIfESC(evt) {
      if (evt.keyCode === 27) {
        this.closeContextual();
      }
    },
    closeContextual() {
      this.editing = null;
    },
    saisieHref(id) {
      const base = process.env.VUE_APP_SAISIE_BASE_URL || 'http://localhost:8080';
      if (!base) return null
      return `${base}/${id}`
    },
    deepFieldSet(o, k, v) {
      let obj = o;
      for (const x of k.split('.').slice(0, -1)) {
        if (!obj[x]) obj[x] = {};
        obj = obj[x];
      }
      obj[k.split('.').slice(-1)[0]] = v;
      return obj;
    },
    deepFieldAccess(obj, path) {
      return path.split(".").reduce((obj, k) => obj && obj[k], obj);
    },
    async sendAction(endpointName, newStatus){
      const { value: formValues } = await this.$swal({
        title: `Action : ${endpointName}`,
        html: `
          <input type="text" required id="input-label" class="swal2-input" placeholder="Label virement">
          <label style="text-transform: unset"><input type="checkbox" id="input-changeStatus"> Set participationValide to ${newStatus}?</label>
        `,
        focusConfirm: false,
        preConfirm: () => {
          const values = {
            label: document.getElementById('input-label').value.trim(),
            changeStatus: document.getElementById('input-changeStatus').checked,
          };
          if (!values.label) {
            this.$swal.showValidationMessage('Please enter a label')
          }
          return values;
        },
        showCancelButton: true,
        confirmButtonText: 'Send',
        cancelButtonText: 'Cancel',
        showLoaderOnConfirm: true,
      })
      if (formValues) {
        try {
          const res = await this.$axios.post(
            `/api/v2/data/${endpointName}`,
            {data: {ids: this.selectedItemIds, label: formValues.label, changeStatus: formValues.changeStatus}},
          )
          if (res.status === 200) {
            await this.$swal({
              type: 'success',
              title: 'Success',
            })
            const filename = res.headers['content-disposition'].match(/filename="(.*)"/)[1];
            const blob = new Blob([res.data], {type: 'text/csv;charset=utf8'});
            downloadBlob(filename, blob);
            await this.loadData();
          }
        } catch (error) {
          console.log(error);
          await this.$swal({
            type: 'error',
            title: 'Error',
            text: (error.response && error.response.data.error) || error.message,
          })
        }
      }
    },
    async loadData() {
      try {
        const submissions = await this.loadSubmissions(true);
        const [operation, title, form] = await Promise.all([
          this.$axios.get(`/api/operations/${this.$route.params._id}`),
          this.$axios.get(`/api/operations/getname/${this.$route.params._id}`),
          this.$axios.get(`/api/v2/formulaires/operation/${this.$route.params._id}`),
        ]);
        this.operation = operation.data;
        const labels = ((form.data[0] || {}).form || []).flatMap(
          (el) => el.fields
        );
        this.title = title.data.title;
        if (this.operation.columnProperty.length) {
          this.columns = this.operation.columnProperty
        } else {
          this.setColumns(submissions, labels);
        }
        // force id column to be present
        if (!this.columns.some(c => c.fieldName === '_id')) {
          this.columns.unshift({ "fieldName": "_id", "hidden": false });
        }
        // force amount_to_refund column to be present on ODR
        if (this.operation.type === 'ODR' && !this.columns.some(c => c.fieldName === 'amount_to_refund')) {
          this.columns.push({ "fieldName": "amount_to_refund", "hidden": false });
        }
      } catch (e) {
        console.error(e);
      }
    },
    async loadSubmissions(resetPagination = false) {
      try {
        this.loading = true;
        this.showFilter = false;
        if (resetPagination) this.page = 1;
        const data = await this.$axios.get(
            `/api/v2/data/${this.$route.params._id}`,
            {
              params: {
                page: this.page,
                limit: this.limit,
                sortDirection: this.sortDirection,
                sortBy: this.sortColumn,
                search: this.search,
                advancedFilters: this.filterOptions,
              },
            }
        );
        let { submissions, submissionsLength } = data.data;
        this.submissionsCount = submissionsLength;
        this.totalPages = Math.ceil(submissionsLength / this.limit);
        this.data = submissions;
        const dates = {};
        this.data = submissions.map((item) => {
          Object.entries(item).forEach(([k, v]) => {
            try{
              if (v === (new Date(v)).toISOString()) {
                dates[k] = true;
                item[k] = this.normalizeDatetime(v);
              }
            } catch(_){}
          })
          return item;
        });
        this.dates = Object.keys(dates);
        this.loading = false;
        return submissions;
      } catch (e) {
        await this.$swal({
          type: 'error',
          title: (e.response && e.response.data.originalMessage) || e.message,
        })
        this.loading = false
      }
    },
    setColumns(data, labels) {
      const blacklist =
          /^(|formulaireId.*|_id.*|url.*|userAgent.*|fingerprint.*|recaptchaV3result.*|address\.(latitude|longitude)|.*_metadata.*)$/;
      let arr = [];
      data.forEach((el) => {
        Object.keys(el).forEach((field) => {
          if (!arr.includes(field)) {
            if (!Array.isArray(el[field]) && el[field]) {
              arr.push(field);
            } else if (Array.isArray(el[field]) && el[field].length) {
              arr.push(field);
            } else if (el[field]) {
              Object.keys(el[field])
                .map((k) => `${field}.${k}`)
                .filter((k) => !arr.includes(k))
                .forEach((k) => arr.push(k));
            }
          }
        });
      });
      arr = arr
        .filter((k) => !blacklist.test(k))
        .map((fieldName) => {
          let item = undefined;
          labels.map((el) => {
            if (el.name === fieldName) {
              item = { fieldName, hidden: false, label: el.label };
            }
          });
          return item ? item : { fieldName, hidden: false };
        });
      this.columns = arr;
    },
    changePage(pageNumberOrDirection) {
      if (pageNumberOrDirection === "prev" && this.page > 1) this.page--;
      if (pageNumberOrDirection === "next" && this.page < this.totalPages)
        this.page++;
      if (typeof pageNumberOrDirection === "number")
        this.page = pageNumberOrDirection;
    },
    sort(fieldName) {
      this.sortColumn = fieldName;
      if (this.sortDirection === "asc") {
        this.sortDirection = "desc";
      } else if (this.sortDirection === "desc") {
        this.sortDirection = "asc";
      }
      this.loadSubmissions(true);
    },
    goToSubmission(id) {
      window.open(`https://saisie.promo.dev/${this.$route.params._id}/${id}?single=true`,'_blank');
    },
    getSubmissionStatusLink(item) {
      return `https://${this.operation.domaine}/status/${item._id}/${item.uid}`;
    },
    async copyValueToClipboard(value) {
      try {
        await navigator.clipboard.writeText(value);
        await this.$swal({
          title: "Copié!",
          type: "success",
          showConfirmButton: false,
          timer: 1000,
        });
      } catch(e) {
        await this.$swal({
        title: "Erreur!",
        type: "error",
        showConfirmButton: false,
        timer: 1000,
      });
      }
    },
    copySubmissionStatusLink(item) {
      this.copyValueToClipboard(this.getSubmissionStatusLink(item))
    },
    goToSubmissionStatus(item) {
      window.open(this.getSubmissionStatusLink(item), '_blank');
    },
    filterDataBtn(el, fieldName) {
      const date = moment(el || '', 'DD/MM/YYYY HH:mm', true);
      if (el == null) {
        this.addFilterOption({
          field: fieldName,
          condition: 'is null',
          value: undefined,
        });
      } else if (date.isValid()) {
        this.addFilterOption({
          field: fieldName,
          condition: 'is on day',
          value: date.format('YYYY-MM-DD'),
        });
      } else {
        this.addFilterOption({
          field: fieldName,
          condition: 'is',
          value: el,
        });
      }
    },
    async downloadCSVData() {
      try {
        this.loadingCsv = true;
        const data = await this.$axios.post(
            `/api/v2/data/${this.$route.params._id}/download`,
            {
              title: this.title,
              page: 1,
              limit: 0,
              sortDirection: this.sortDirection,
              sortBy: this.sortColumn,
              search: this.search,
              selectedItemIds: this.selectedItemIds,
              columns: this.columns,
              advancedFilters: this.filterOptions,
            },
        );
        const filename = data.headers['content-disposition'].match(/filename="(.*)"/)[1];
        const blob = new Blob([data.data], {type: 'text/csv;charset=utf8'});
        downloadBlob(filename, blob);
      } catch (e) {
        await this.$swal({
          type: 'error',
          title: 'Error',
          text: (e.response && e.response.data.error) || e.message,
        })
        console.log(e);
      }
      this.loadingCsv = false;
    },
    checkItem(item, event) {
      event.target.checked
        ? this.selectedItemIds.push(item._id)
        : (this.selectedItemIds = this.selectedItemIds.filter(
            (el) => el !== item._id
          ));
    },
    toggleCheckedItems() {
      this.selectedItemIds = [];
      if (this.data.some((el) => el.checked)) {
        this.data.forEach((el) => (el.checked = false));
      } else {
        this.data.forEach((el) => (el.checked = true));
        this.data.forEach((el) => this.selectedItemIds.push(el._id));
      }
    },
    async deleteItems(ids) {
      let data = {
        ids: Array.isArray(ids) ? ids : [ids],
      };
      try {
        let confirmation = await this.$swal({
          title: "&Ecirc;tes vous sûr ?",
          text: `Supprimer ${data.ids.length} ${
            data.ids.length === 1 ? "participation" : "participations"
          }?`,
          type: "warning",
          showCancelButton: true,
          cancelButtonText: "Annuler",
          confirmButtonText: "Oui, supprimer",
        });
        if (confirmation.value) {
          const response = await this.$axios.delete(`/api/v2/data/delete`, {data});
          if (response.status === 200) {
            await this.$swal({
              title: "Supprimé !",
              text: `${data.ids.length} ${
                  data.ids.length === 1
                    ? "participation supprimée"
                    : "participations supprimées"
              } avec succès`,
              type: "success",
              timer: 2000,
            });
            await this.loadSubmissions();
          }
        }
      } catch (error) {
        console.log(error);
        await this.$swal({
          type: 'error',
          title: 'Error',
          text: (error.response && error.response.data.error) || error.message,
        })
      }
    },
    async changeItemsStatus(ids, status) {
      let data = Array.isArray(ids) ? ids : [ids];
      try {
        let confirmation = await this.$swal({
          title: "&Ecirc;tes vous sûr ?",
          text: `Changer le statut de ${data.length} ${
            data.length === 1 ? "participation" : "participations"
          } en ${status.label}?`,
          type: "warning",
          showCancelButton: true,
          cancelButtonText: "Annuler",
          confirmButtonText: "Oui, changer",
        });
        if (confirmation.value) {
          const response = await this.$axios.put(`/api/v2/data/update-status`,{data: { ids: data, status: status.value }})
          if(response.status === 204) {
            await this.$swal({
              title: "Changement de statut",
              text: `${data.length} ${
                  data.length === 1
                  ? "participation modifiée"
                  : "participations modifiées"
              } avec succès`,
              type: "success",
              timer: 2000,
            });
            this.selectedItemIds = [];
            await this.loadSubmissions();
          }
        }
      } catch (error) {
        console.log(error);
        await this.$swal({
          type: 'error',
          title: 'Error',
          text: (error.response && error.response.data.error) || error.message,
        })
      }
    },
    toggleItemVisibility(item) {
      item.hidden = !item.hidden;
    },
    async saveColumnsOrder() {
      try {
        const response = await this.$axios.put(
            `/api/operations/update/${this.$route.params._id}`,
          { columnProperty: this.columns },
        );
        if (response.status === 200) {
          await this.$swal({
            title: "Enregistré !",
            text: "Ordre des colonnes enregistré avec succès",
            type: "success",
            timer: 2000,
          });
        }
      } catch (e) {
        console.log(e);
      }
    },
    normalizeDatetime(datetime) {
      return moment(datetime).format("DD/MM/YYYY HH:mm");
    },
    localToIsoDatetime(local) {
      return moment(local, "DD/MM/YYYY HH:mm").toISOString();
    },
    hideShowFilter({target}) {
      if (!target.closest('.advanced-filters') && !target.closest('.advanced-filters__btn')) {
        this.showFilter = false
      }
    }
  },
  computed: {
    filterOptions () {
      return this.rawFilterOptions.filter(el => el.field && el.condition)
    },
    filterOptionsIsFilled () {
      return this.filterOptions.length > 0
    },
    editingDirty() {
        return this.editing && this.editing.value !== this.editing.originalValue;
    },
    isAllRefundOrValid() {
      return this.data.filter(el => this.selectedItemIds.includes(el._id)).every(el => ['VALID', 'REFUND_DONE'].includes(el.participationValide))
    },
  },
  unmounted() {
    document.removeEventListener('keyup', this.closeIfESC);
    document.removeEventListener('click', this.closeIfNotEditing);
  },
  mounted() {
    this.loadData();
    document.addEventListener('keyup', this.closeIfESC);
    document.addEventListener('click', this.closeIfNotEditing);
  },
  watch: {
    async page() {
      await this.loadSubmissions();
    },
    async limit() {
      localStorage.limit = this.limit;
      await this.loadSubmissions(true);
    },
    data() {
      this.editing = null;
    },
    showFilter() {
      if (this.showFilter) {
        document.addEventListener('click', this.hideShowFilter)
      } else {
        document.removeEventListener('click', this.hideShowFilter)
      }
    }
  },
};
</script>

<style scoped lang="scss">
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
.zoomedWrapper {
  position: relative;
  &.zoomed {
    position: fixed;
    inset: 0;
    background: linear-gradient(110deg, #f8faff, #e0ecfc);
    .submission-table__wrapper {
      height: calc(100vh - 15rem);
      max-height: unset
    }
    .wrapper {
      border: 0;
      border-radius: 0;
    }
  }
}
.btn-zoom {
  padding: 0;
  margin-right: 10px;
  width: 30px;
  height: 30px;
  border: 2px solid #ff8000;
  color: #ff8000;
  transition: all 0.3s ease,right 0s ease;
  &:hover {
    background: #ff8000;
    color: #000;
   }
}

.wrapper {
  border: 2px solid #3f3f3f;
  border-radius: 5px;
  background: linear-gradient(110deg, #f8faff, #e0ecfc);
}



.header {
  padding: 10px;
}

.dragable {
  position: absolute;
  width: 100%;
  top: 50px;
  padding: 5px 15px;
  border: 2px solid black;
  z-index: 999;
  background: #fff;

  .list {
    margin: 10px 0;
  }

  .list span {
    display: flex;
    flex-wrap: wrap;
  }

  .list div {
    list-style: none;
    cursor: pointer;
    padding: 10px 5px;
    margin: 4px 2px;
    border: 1px solid #3f3f3f;
    border-radius: 5px;
    background: linear-gradient(110deg, #f8faff, #e0ecfc);
  }
}

.submission-table {
  &__wrapper {
    width: 100%;
    min-height: 15rem;
    max-height: calc(100vh - 40rem);
    margin: 0 auto;
    overflow-x: scroll;
  }
  background: linear-gradient(110deg, #f8faff, #e0ecfc);
  border-collapse: collapse;
  position: relative;
  width: 100%;
}

td,
th {
  padding: 10px;
  position: relative;
}

th {
  border-top: 1px solid #3f3f3f;
  border-bottom: 1px solid #3f3f3f;
  background: #d9d9d9;
  position: relative;
}

th:after {
  content: "";
  position: absolute;
  right: 0;
  top: 30%;
  width: 1px;
  background: #3f3f3f;
  opacity: 50%;
  height: 40%;
}

th span {
  display: flex;
  align-items: center;
}

th i {
  padding-left: 5px;
}

tr {
  border-bottom: 2px solid #3f3f3f;
  vertical-align: center;
}

tr:last-child {
  border: none;
}

tr:nth-child(even) {
  background: linear-gradient(110deg, #eeeeef, #e9eaec);
}

thead {
  position: sticky;
  top: 0;
  z-index: 1;
}

.cell__content {
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.cell__content span {
  max-width: 20em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cell__content__hover {
  display: flex;
  opacity: 0;
  width: 100%;
  align-items: flex-start;
  justify-content: space-between;
  background: linear-gradient(110deg, #f8faff, #e0ecfc);
  box-shadow: 0 2px 10px #0004;
  white-space: pre-wrap;
  word-break: break-all;
  padding: 10px;
  margin: -10px;
  border-radius: 5px;
  z-index: 1;
  position: absolute;
  top: 17px;
  left: 10px;
}

.cell__content__hover input {
  width: 100%;
  padding: 0 .5em;
}

.contextual {
    background: white;
    border: 1px solid rgba(10, 22, 70, 0.06);
    border-radius: 4px;
    box-shadow: rgba(10, 22, 70, 0.06) 0px 0px 1px 0px, rgba(10, 22, 70, 0.1) 0px 6px 6px 0px;
}

.contextual > form {
    min-width: 350px;
    word-break: normal;
    padding: 1em 1em;
}

.contextual > form > div {
    opacity: 1;
    display: flex;
}

.contextual > form > p {
    color: red;
}

.contextual form > div > * {
    margin-right: 8px;
}

.contextual > form > div > button {
    display: inline-flex;
    flex-direction: row;
    flex: 1;
}

.contextual > ul {
    list-style: none;
}
.contextual > ul > li {
    padding: 1em 2em;
    cursor:   pointer;
}
.contextual > ul > li:hover {
    background: rgba(0,0,0,.05);
}

.cell__content i {
  opacity: 0;
  transition: 0.3s all ease;
}

td:hover .cell__content__hover {
  opacity: 1;
}

tr:nth-child(even) td:hover .cell__content__hover {
  background: linear-gradient(110deg, #eeeeef, #e9eaec);
}

td:hover i {
  opacity: 1;
}

button {
  padding: 5px 15px;
  background: transparent;
  border: 2px solid #6462f2;
  border-radius: 5px;
  color: #6462f2;
  font-weight: bold;
  transition: all 0.3s ease;
}
button.btnWithSpinner {
  white-space: nowrap;
  display: flex;
  align-items: center;
  column-gap: 5px;
}
button.btnWithSpinner > i {
  font-size: 18px
}

button:hover {
  background: #6462f2;
  border-color: #000;
  color: #fff;
}

button:disabled {
  background: #ccc;
  filter: saturate(0);
  opacity: 0.5;
  pointer-events: none;
}

.search {
  position: relative;
  display: flex;
  justify-content: space-between;
  column-gap: 10px;
  margin: 10px 0;
  padding: 0 10px;
}

.search > input {
  width: 100%;
}

.search select {
  width: 25%;
  min-width: 100px;
}
.advanced-filters {
  position: absolute;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  z-index: 999;
  top: 36px;
  right: 25px;
  background: #fff;
  border: 2px solid #6462f2;
  box-shadow: 0 3px 8px #6462f2aa;
  border-radius: 5px;
  padding: 10px 15px;
  width: 650px;
  &__item {
    display: flex;
    align-items: center;
    column-gap: 10px;

    input[type="text"] {
      flex: 1;
    }
  }
  &__btn {
    position: relative;
  }

  &__btn.active{
    background: #fff;
    border-color: #6462f2;
    color: #6462f2;
    border-radius: 5px 5px 0 0;
    border-bottom-color: #fff;
    z-index: 1000;
  }

  &__badge {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: -10px;
    right: -10px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid #6462f2;
    background: #fff;
    color: #6462f2;
    z-index: 2;
  }
  &__buttons {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    > div {
      display: flex;
      column-gap: 10px;
    }
  }
}

.pagination {
  &__wrapper {
    display: flex;
    justify-content: center;
    margin: 10px 0;
  }
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  button {
    color: black;
    padding: 8px 16px;
    text-decoration: none;
    border: 1px solid #ddd;
    &:disabled {
      background-color: #ddd;
      color: #aaa;
      cursor: inherit;
    }
    &.active {
      background-color: #6462f2;
      color: white;
      border: 1px solid #6462f2;
    }
    &:hover:not(.active) {
      background-color: #ddd;
    }
    &:first-child {
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }
    &:last-child {
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }
  }
}

.not-found {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 150px;
  font-size: 2rem;
  text-transform: uppercase;
}

.nowrap {
  white-space: nowrap;
}
</style>
